export default "__VITE_ASSET__BGwP2lJD__"